import { centerCrop, makeAspectCrop } from 'react-image-crop';

export function centerAspectCrop(
  mediaWidth: number,
  mediaHeight: number,
  aspect: number,
  width = 90
) {
  const crop = centerCrop(
    makeAspectCrop(
      {
        unit: '%',
        width: width,
      },
      aspect,
      mediaWidth,
      mediaHeight
    ),
    mediaWidth,
    mediaHeight
  );

  return crop;
}

export function leftAspectCrop(
  mediaWidth: number,
  mediaHeight: number,
  aspect: number
) {
  const crop = centerCrop(
    makeAspectCrop(
      {
        unit: '%',
        height: 90,
      },
      aspect,
      mediaWidth,
      mediaHeight
    ),
    mediaWidth,
    mediaHeight
  );

  crop.x = 0;

  return crop;
}

export function rightAspectCrop(
  mediaWidth: number,
  mediaHeight: number,
  aspect: number
) {
  const crop = centerCrop(
    makeAspectCrop(
      {
        unit: '%',
        height: 90,
      },
      aspect,
      mediaWidth,
      mediaHeight
    ),
    mediaWidth,
    mediaHeight
  );

  crop.x = 100 - crop.width;

  return crop;
}
